
import { transmissionProducts } from "./products/transmission";
import { brakeProducts } from "./products/brake";
import { chassisProducts } from "./products/chassis";
import { structuralProducts } from "./products/structural";
import { Product } from "@/types/product";

export const products: Product[] = [
  ...transmissionProducts,
  ...brakeProducts,
  ...chassisProducts,
  ...structuralProducts
];

export const faqQuestions = [
  {
    question: "What certifications do your exported parts have?",
    answer: "Our parts are certified with ISO 9001:2015, TS 16949, and CE marking. We maintain strict quality control standards for international markets."
  },
  {
    question: "What is the minimum order quantity for international shipments?",
    answer: "Our standard MOQ is 100 units per product. We offer flexible terms for regular importers and distributors."
  },
  {
    question: "Which regions do you currently export to?",
    answer: "We export globally with strong presence in Africa, Middle East, and Europe. We have established logistics networks through major ports including Dubai, Mombasa, and Rotterdam."
  }
];
